import {
  Component,
  OnInit,
  Input
} from '@angular/core';
import {
  ManagerStatisticSummaryInterface
} from '../../../models/avg-learners-statistic.model';
import { CardConfig } from '../../../models/ui-config.models';

@Component({
  selector: 'app-calls-cards-advanced',
  templateUrl: './calls-cards-advanced.component.html',
  styleUrls: ['./calls-cards-advanced.component.scss'],
})

export class CallsCardsAdvancedComponent implements OnInit {
  @Input() userType  = 'learner'; // 'learner' or 'manager'
  @Input() cards: CardConfig[];
  @Input() statistic: ManagerStatisticSummaryInterface;

  constructor() { }

  ngOnInit() {
  }

  public getProgressColor(percent: number): string {
    if (percent < 30) {
      return 'danger';
    }
    if (percent < 60) {
      return 'orange';
    }
    return 'success';
  }
}
